import { render, staticRenderFns } from "./student-detail.vue?vue&type=template&id=c2a20856&scoped=true"
import script from "./student-detail.vue?vue&type=script&lang=js"
export * from "./student-detail.vue?vue&type=script&lang=js"
import style0 from "./student-detail.vue?vue&type=style&index=0&id=c2a20856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a20856",
  null
  
)

export default component.exports